<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS</span>
                </h4>
                <filtros @pesquisar="pesquisar($event)"></filtros>
                <app-tabela
                    idTabela="tblContratos"
                    :itens="contratos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="preContrato()"
                                v-if="$temAcessoView('CONT-PRE-00')"
                                >Novo contrato</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="nuValorGlobalContrato" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuValorGlobalContrato | currency
                        }}</span>
                    </template>
                    <template slot="nuSaldoContrato" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuSaldoContrato | currency
                        }}</span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{
                            data.dtInicioVigencia
                                ? $moment(data.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{
                            data.dtFimVigencia
                                ? $moment(data.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="prazoConclusao" slot-scope="data">
                        {{ data.prazoConclusao }}
                        <span>dia(s)</span>
                    </template>
                    <template slot="noPrazo" slot-scope="data">
                        <app-status
                            :status="data.noPrazo ? 'NO PRAZO' : 'VENCIDO'"
                        ></app-status>
                    </template>
                    <template slot="situacaoContrato" slot-scope="data">
                        <app-status
                            :status="data.situacaoContrato.toUpperCase()"
                            :contrato="data"
                            :showErrorBadge="false"
                        ></app-status>
                    </template>
                    <template slot="nuSaldoContrato" slot-scope="data">{{
                        data.nuSaldoContrato | currency
                    }}</template>
                    <template slot="nuSaldoContratoReal" slot-scope="data">{{
                        data.nuSaldoContratoReal | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary mr-1"
                            v-if="$temAcessoView('CONT-01')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharContrato(data.idContrato)"
                            ></i>
                        </span>
                        <span
                            class="text-primary"
                            v-if="
                                $temAcessoView('CONT-PRE-01') &&
                                data.idSituacaoContrato ==
                                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            "
                        >
                            <i
                                class="fa fa-edit fa-lg icon-button"
                                title="Editar"
                                @click.stop="editarContrato(data.idContrato)"
                            ></i>
                        </span>
                        <span
                            class="text-danger"
                            v-if="temAcessoExclusaoContrato(data)"
                        >
                            <i
                                class="fa fa-trash fa-lg icon-button"
                                title="Excluir Alerta"
                                @click.stop="confirmarExcluir(data)"
                            ></i>
                        </span>
                    </template>
                    <template slot="vinculoRM" slot-scope="data">
                        <app-status
                            :status="data.vinculoRM ? 'OK' : 'NOK'"
                        ></app-status>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import ContratosServicos from './ContratosServicos'
import { situacaoContrato } from './SituacaoContrato'
import Filtros from './Filtros.vue'

export default {
    components: {
        Filtros
    },

    data() {
        return {
            contratos: [],
            filtroDto: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Código do Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'processoCliente',
                    label: 'Processo Cliente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjetoContrato',
                    label: 'Objeto do Contrato',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuValorGlobalContrato',
                    label: 'Valor do Contrato'
                },
                {
                    key: 'nuSaldoContrato',
                    label: 'Saldo Previsto'
                },
                {
                    key: 'nuSaldoContratoReal',
                    label: 'Saldo Real'
                },
                {
                    key: 'vigencia',
                    label: 'Prazo'
                },
                {
                    key: 'prazoConclusao',
                    label: 'Dias para Vencimento',
                    sortable: true
                },
                {
                    key: 'situacaoContrato',
                    label: 'Situação',
                    filterable: true
                },
                {
                    key: 'noPrazo',
                    label: 'Status'
                },
                {
                    key: 'vinculoRM',
                    label: 'RM'
                }
            ],
            itensPorPagina: 5,
            situacaoContrato: situacaoContrato
        }
    },
    methods: {
        obterContratos(filtro) {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterTodos(filtro).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar(filtroDto) {
            this.filtroDto = filtroDto
            this.obterContratos(filtroDto)
        },

        preContrato() {
            this.$router.push({
                name: `${this.$route.name}_Inserir_Precontrato`
            })
        },

        detalharContrato(id) {
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: id
                }
            })
        },

        editarContrato(id) {
            this.$router.push({
                name: 'Contratos_Editar',
                params: {
                    contratoId: id
                }
            })
        },

        excluirContrato(contrato) {
            this.$store.dispatch('addRequest')
            ContratosServicos.excluirContrato(contrato).then((response) => {
                if (response.success) {
                    this.registroExcluidoComSucesso(contrato)
                } else {
                    this.erros = response.errors
                }
                this.$store.dispatch('removeRequest')
            })
        },

        isToObterContratos() {
            return (
                this.$route.name !== 'Contratos_Comprometimentos' &&
                this.$route.name !== 'Contratos_Pagamentos' &&
                this.$route.name !== 'Contratos_Pagamentos_Detalhar' &&
                this.$route.name !==
                    'Contratos_Pagamentos_AssociarComprometimentos' &&
                this.$route.name !== 'Contratos_Requisicoes' &&
                this.$route.name !== 'Contratos_Requisicoes_Detalhar'
            )
        },

        confirmarExcluir(contrato) {
            var aditivo = this.situacoesExclusaoAditivo.includes(
                contrato.idSituacaoContrato
            )
            this.$swal({
                title: 'Exclusão de ' + (aditivo ? 'Aditivo' : 'Contrato'),
                html:
                    'Confirma a exclusão do ' +
                    (aditivo ? 'aditivo' : 'contrato') +
                    ' nº ' +
                    contrato.vcCodigoEstruturado +
                    '?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirContrato(contrato)
                }
            })
        },

        registroExcluidoComSucesso(contrato) {
            var aditivo = this.situacoesExclusaoAditivo.includes(
                contrato.idSituacaoContrato
            )
            this.$toast.success(
                (aditivo ? 'Aditivo' : 'Contrato') +
                    ' nº ' +
                    contrato.vcCodigoEstruturado +
                    ' excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.obterContratos(this.filtroDto)
        },

        temAcessoExclusaoContrato(contrato) {
            return (
                (this.$temAcessoView('CONT-APOST-01') ||
                    this.$temAcessoView('CONT-ELAB-00') ||
                    this.$temAcessoView('CONT-ELAB-01') ||
                    this.$temAcessoView('CONT-ADITIV-00') ||
                    this.$temAcessoView('CONT-ADITIV-01') ||
                    this.$temAcessoView('CONT-ATUALIZAR-00')) &&
                (!contrato.vinculoRM ||
                    this.situacoesExclusaoAditivo.includes(
                        contrato.idSituacaoContrato
                    ))
            )
        }
    },

    created() {
        if (this.isToObterContratos()) {
            this.obterContratos(null)
        }
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Contratos'
        },

        situacoesExclusaoAditivo() {
            return [
                situacaoContrato.INICIADO_ADITIVO_CONTRATO,
                situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO,
                situacaoContrato.ADITIVO_AGUARDANDO_JOB_DE_INTEGRACAO,
                situacaoContrato.ERRO_INTEGRACAO
            ]
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'Contratos') {
                if (
                    this.$store.getters.recarregar ||
                    from.name == 'Contratos_Comprometimentos' ||
                    from.name == 'Contratos_Pagamentos' ||
                    from.name == 'Contratos_Pagamentos_Detalhar' ||
                    from.name ==
                        'Contratos_Pagamentos_AssociarComprometimentos' ||
                    from.name == 'Contratos_Requisicoes'
                ) {
                    this.obterContratos(null)
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
